import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import Small from 'UIComponents/elements/Small';
import { InsertImageIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { CardHero } from 'foundations-components/transitional/components/CardHero';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { STAR_RATING_FILLED } from 'marketplace-ui-reviews/constants/RatingTypes';
import { MINIMUM_REVIEWS_FOR_DISPLAY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { cloneElement } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetCard({
  companyName,
  detailsButton,
  demoButton,
  name,
  priceCents,
  providerName,
  reviewSummary,
  thumbnailUrl,
  offeringType
}) {
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const renderedPrice = priceCents != null ? /*#__PURE__*/_jsx(Text, {
    typography: "heading-300",
    paddingInline: "200",
    children: priceCents === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-assets-core.assetCard.planType.free"
    }) : /*#__PURE__*/_jsx(FormattedIntlCurrency, {
      currencyCode: "USD",
      trailingZeroDisplay: "stripIfInteger",
      value: formatCentsToDollars(priceCents)
    })
  }) : null;
  const renderedOfferingMetaInfo = /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "100",
    paddingBlock: "200",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-400",
      marginBlockEnd: "0",
      children: name
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.assetCard.companyName",
          options: {
            companyName: providerName || companyName || ''
          }
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      paddingBlockStart: "100",
      inlineSize: "100%",
      children: [/*#__PURE__*/_jsx(UIBadge, {
        use: offeringType === 'THEME' ? 'thunderdome' : 'norman',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `marketplace-ui-assets-core.assetCard.offeringType.${offeringType}`
        })
      }), renderedPrice]
    })]
  });
  const renderedReviewSummary = reviewSummary && reviewSummary.reviewCount >= MINIMUM_REVIEWS_FOR_DISPLAY ? /*#__PURE__*/_jsx(Rating, {
    rating: reviewSummary.overallRating,
    label: reviewSummary.reviewCount,
    use: "card",
    type: STAR_RATING_FILLED
  }) : /*#__PURE__*/_jsx("span", {});
  const renderButtons = (detailsButton || demoButton) && /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "center",
    paddingBlockStart: "100",
    paddingInlineStart: "200",
    flexWrap: isMobileView ? 'wrap' : 'nowrap',
    justifyContent: "end",
    children: [detailsButton && /*#__PURE__*/cloneElement(detailsButton, {
      size: 'small'
    }), demoButton && /*#__PURE__*/cloneElement(demoButton, {
      size: 'small'
    })]
  });
  return /*#__PURE__*/_jsxs(CardWrapper, {
    compact: true,
    "data-test-id": "assetcard-wrapper",
    children: [thumbnailUrl ? /*#__PURE__*/_jsx(CardHero, {
      children: /*#__PURE__*/_jsx(Image, {
        src: thumbnailUrl,
        blockSize: "360px",
        role: "presentation"
      })
    }) : /*#__PURE__*/_jsx(Flex, {
      "data-test-id": "assetcard-thumbnail-placeholder",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "fill-surface-raised",
      children: /*#__PURE__*/_jsx(IconHolder, {
        icon: InsertImageIcon,
        size: "1300",
        color: "border-core-default"
      })
    }), /*#__PURE__*/_jsxs(View, {
      padding: "500",
      children: [/*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "space-between",
        flexGrow: 0,
        children: renderedOfferingMetaInfo
      }), /*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "end",
        children: [renderedReviewSummary, renderButtons]
      })]
    })]
  });
}